// Delivery estimate: counts business days (Mon–Fri) from today, or from the next business day once
// the daily cutoff hour has passed, in the store's time zone (data-time-zone). Fills [data-delivery-date]
// and, when the next cutoff is under 24 hours away, a "order within Xhr Ymin" countdown refreshed each minute.
class DeliveryEstimate extends HTMLElement {
  #timer = 0;

  connectedCallback() {
    this.#render();
    this.#timer = window.setInterval(() => this.#render(), 60000);
  }

  disconnectedCallback() {
    window.clearInterval(this.#timer);
  }

  #render() {
    const timeZone = this.dataset.timeZone || 'America/New_York';
    const cutoff = Number(this.dataset.cutoff ?? 14);
    const days = Math.max(1, Number(this.dataset.days ?? 5));
    const parts = Object.fromEntries(
      new Intl.DateTimeFormat('en-US', { timeZone, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' })
        .formatToParts(new Date())
        .map((part) => [part.type, part.value]),
    );
    const minutesNow = Number(parts.hour) * 60 + Number(parts.minute);
    // Calendar arithmetic on a UTC date that stands for the store's local date.
    const day = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day)));
    const isBusinessDay = (date) => date.getUTCDay() !== 0 && date.getUTCDay() !== 6;

    let daysUntilShip = 0;
    if (!isBusinessDay(day) || minutesNow >= cutoff * 60) {
      do {
        day.setUTCDate(day.getUTCDate() + 1);
        daysUntilShip += 1;
      } while (!isBusinessDay(day));
    }
    const minutesLeft = daysUntilShip * 1440 + cutoff * 60 - minutesNow;

    let added = 0;
    while (added < days) {
      day.setUTCDate(day.getUTCDate() + 1);
      if (isBusinessDay(day)) added += 1;
    }

    const dateEl = this.querySelector('[data-delivery-date]');
    if (dateEl) {
      dateEl.textContent = new Intl.DateTimeFormat(this.dataset.locale || 'en', { timeZone: 'UTC', weekday: 'short', month: 'short', day: 'numeric' }).format(day);
    }
    const wrap = this.querySelector('[data-delivery-countdown-wrap]');
    const countdown = this.querySelector('[data-delivery-countdown]');
    if (wrap && countdown) {
      const showCountdown = minutesLeft > 0 && minutesLeft < 1440;
      wrap.hidden = !showCountdown;
      if (showCountdown) countdown.textContent = `${Math.floor(minutesLeft / 60)}hr ${minutesLeft % 60}min`;
    }
    this.hidden = false;
  }
}

if (!customElements.get('s-delivery-estimate')) customElements.define('s-delivery-estimate', DeliveryEstimate);
